export { Idle } from './idle';
export { NotIdle } from './not-idle';
//# sourceMappingURL=/home/travis/build/harunurhan/idlejs/src/index.js.map